import { render, staticRenderFns } from "./MyPaymentsTableUser.vue?vue&type=template&id=06f2eb5a&scoped=true"
import script from "./MyPaymentsTableUser.vue?vue&type=script&lang=js"
export * from "./MyPaymentsTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2eb5a",
  null
  
)

export default component.exports